"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const webexUI_1 = require("webexUI");
const index_1 = require("../../Pages/index");
const LocationFilterHelper_1 = require("../FilterableList/LocationFilterHelper");
const FilterTypings_1 = require("../Filters/FilterTypings");
const FilterableDataLoader_1 = require("./FilterableDataLoader");
const FilterableListService_1 = require("./FilterableListService");
const BaseFilterableListContainer_1 = require("./BaseFilterableListContainer");
class FilterableListContainer extends React.Component {
    constructor(props) {
        super(props);
        this.prepareSelectedFilters = (selectedFiltersList, _pageNumber, _pageSize, _sortBy) => {
            this.previouslySelectedFilters = selectedFiltersList;
            return selectedFiltersList;
        };
        this.onDataLoaded = (filteredData, initialData, selectedFiltersList) => {
            this.addSelectedDisabledFilters(filteredData.filters, this.previouslySelectedFilters, initialData.filters);
            const filteredDataWithDefaultType = this.setDefaultTypeFilter(initialData, filteredData);
            this.locationFilterHelper &&
                this.locationFilterHelper.onDataLoaded(filteredDataWithDefaultType, selectedFiltersList);
            this.setState({ informationMessage: filteredData.informationMessage });
        };
        this.setDefaultTypeFilter = (initialData, filteredData) => {
            const initialFilters = (0, webexUI_1.safe)(initialData.filters);
            const selectedFilters = (0, webexUI_1.safe)(filteredData.filters);
            const initGroupTypeFilter = this.getFiltersByTypeAlias(FilterTypings_1.FilterGroupTypeAlias.Type, initialFilters);
            // if there is no initial type filter no reason to set distributor type as default
            if (!initGroupTypeFilter.length) {
                return filteredData;
            }
            // check filter items and set default filter
            const selectedFiltersTypeItems = this.getFiltersByTypeAlias(FilterTypings_1.FilterGroupTypeAlias.Type, selectedFilters)[0].items;
            if (selectedFiltersTypeItems &&
                selectedFiltersTypeItems.length &&
                selectedFiltersTypeItems.some(item => item.selected)) {
                return filteredData;
            }
            const newSelectedData = Object.assign({}, filteredData);
            newSelectedData.filters.forEach(filterItem => {
                if (filterItem.typeAlias === FilterTypings_1.FilterGroupTypeAlias.Type) {
                    filterItem.items = this.mergeAndSelectItems(filterItem.items, initGroupTypeFilter[0].items);
                }
            });
            return newSelectedData;
        };
        // NEED CHECK
        this.mergeAndSelectItems = (filterItems, initItems) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const filterItemsList = (0, webexUI_1.safe)(filterItems);
            const initItem = initItems.filter(item => {
                item.selected = true;
                return item;
            });
            return filterItemsList.push(initItem);
        };
        this.getFiltersByTypeAlias = (filterType, filters) => {
            return filters.filter(filterItem => filterItem.typeAlias === filterType);
        };
        this.prepareChangedFilters = (groupValue, newFilterValue, filters, selectedFilters, _unselect) => {
            if (selectedFilters[groupValue].indexOf(newFilterValue) > -1 ||
                (selectedFilters[groupValue].length === 0 && newFilterValue === '')) {
                return null;
            }
            let newSelectedFilters = Object.assign({}, selectedFilters);
            if (this.locationFilterHelper) {
                newSelectedFilters = this.locationFilterHelper.onLocationFilterChange(filters, newFilterValue, newSelectedFilters, groupValue);
            }
            if (groupValue === FilterTypings_1.FilterGroupTypeAlias.Type) {
                this.setState({ informationMessage: null, showInfoMessage: true });
            }
            return { filters, selectedFilters: newSelectedFilters };
        };
        this.changeInfoMessageStatus = (isVisible) => {
            !!this.state.informationMessage && this.setState({ showInfoMessage: isVisible });
        };
        this.onInfoMessageClose = () => {
            this.changeInfoMessageStatus(false);
            this.setState({ informationMessage: null });
        };
        this.addSelectedDisabledFilters = (receivedFilters, previouslySelectedFilters, initialFilters) => {
            previouslySelectedFilters.forEach(selectedFilter => {
                const currentSelectedFilter = selectedFilter && selectedFilter.split(':');
                if (!currentSelectedFilter || currentSelectedFilter.length <= 1) {
                    return;
                }
                const filterGroupValue = currentSelectedFilter[0];
                const filterGroup = this.getFilterByValue(filterGroupValue, receivedFilters);
                // if we have filter group with such name in received filters
                // and we don't have filter item within this group
                if (!filterGroup ||
                    filterGroup.guiType === FilterTypings_1.FilterGroupGuiTypeEnum.Autosuggest ||
                    this.getFilterByValue(selectedFilter, filterGroup.items)) {
                    return;
                }
                const initialFilterGroup = this.getFilterByValue(filterGroupValue, initialFilters);
                // then find such filter group in initial filters
                if (initialFilterGroup) {
                    const initialFilter = this.getFilterByValue(selectedFilter, initialFilterGroup.items);
                    if (!initialFilter) {
                        return;
                    }
                    filterGroup.items.push(Object.assign(Object.assign({}, initialFilter), { selected: true, documentsCount: 0 }));
                    // make it selected and disabled
                    (0, app_1.sortByKey)(filterGroup.items, 'title');
                }
            });
        };
        this.updateReactState = (newState) => {
            this.setState(newState);
        };
        this.state = { showInfoMessage: true };
        let apiUrl = '';
        if (this.props.additionalData) {
            const filterProps = {
                apiCitiesUrl: this.props.additionalData.apiCitiesUrl,
                culture: this.props.additionalData.culture,
                locationApiUrl: this.props.additionalData.locationApiUrl,
                locationApiKey: this.props.additionalData.locationApiKey,
                pageId: index_1.PageContext.pageId,
                setState: this.updateReactState,
            };
            this.locationFilterHelper = new LocationFilterHelper_1.LocationFilterHelper(filterProps);
            apiUrl = this.props.additionalData.apiUrl;
        }
        this.dataLoader = new FilterableDataLoader_1.FilterableDataLoader({
            dataLoadedSuccessHandler: this.onDataLoaded,
            pageId: index_1.PageContext.pageId,
            pageName: index_1.PageContext.pageName,
            prepareSelectedFiltersHandler: this.prepareSelectedFilters,
            service: this.props.service || new FilterableListService_1.FilterableListService(apiUrl),
            storeFiltersInHistory: false,
        });
        localStorage.setItem('searchApiUrl', this.props.service.config.searchUrl);
    }
    render() {
        const additionalData = Object.assign(Object.assign({}, this.props.additionalData), { citiesOptions: this.state.citiesOptions, countryOptions: this.state.countryOptions, informationMessage: this.state.informationMessage, onInfoMessageClose: this.onInfoMessageClose, pageid: index_1.PageContext.pageId, showInfoMessage: this.state.showInfoMessage, stateOptions: this.state.stateOptions });
        return ((0, jsx_runtime_1.jsx)(BaseFilterableListContainer_1.BaseFilterableListContainer, { renderIn: FilterTypings_1.BaseFilterableListParent.FilterableListContainer, additionalData: additionalData, isUnderDevelopment: !this.props.service && !additionalData.apiUrl, dataLoader: this.dataLoader, prepareChangedFiltersHandler: this.prepareChangedFilters, defaultCountryPromise: this.props.defaultCountryPromise }));
    }
    getFilterByValue(value, filters) {
        const valueIndex = (0, app_1.findIndex)(filters, element => {
            return element && element.value === value;
        });
        return valueIndex > -1 ? filters[valueIndex] : null;
    }
}
exports.FilterableListContainer = FilterableListContainer;
